import * as React from 'react';

import './Overlay.scss'

type Props = {
    onOverlayClick?: () => void;
    children?: React.ReactNode;
};

export const Overlay: React.FC<Props> = (props): React.ReactElement => {
    return (
        <div className="cr-modal-overlay" onClick={() => props.onOverlayClick && props.onOverlayClick()}>
            <div onClick={e => e.stopPropagation()}>
                {props.children}
            </div>
        </div>
    );
};

